module.exports = __webpack_public_path__ + "img/allgemeine-struktur.22415a52.png";